import { render, staticRenderFns } from "./TableDetails.vue?vue&type=template&id=fd490530&"
import script from "./TableDetails.vue?vue&type=script&lang=js&"
export * from "./TableDetails.vue?vue&type=script&lang=js&"
import style0 from "./TableDetails.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TableDetails.vue"
export default component.exports